export const URI = {
    PRIVACY_POLICY: 'https://www.thrivestack.ai/privacy',
    TERMS_OF_SERVICE: 'https://www.thriveStack.ai/terms-of-use'
}